/**
 * @file Plain-language ("dla 18-latka") descriptions for each screen, shown in
 * the sidebar ⓘ tooltips. Keyed by the nav key suffix (after "nav:"). Written
 * for a no-code user — what the screen is and what it concretely does, no jargon.
 */

export const SCREEN_HELP: Record<string, string> = {
  commandCenter:
    "Twój poranny pulpit. Krótki briefing dnia: co ważne, jakie masz następne ruchy i co czeka na Twoją decyzję.",
  inbox:
    "Szybka wrzutka. Łapiesz myśl, zadanie albo zrzut ekranu w 2 sekundy, zanim ucieknie — później zamieniasz to na zadanie.",
  today:
    "Co masz dziś do zrobienia: wybrane zadania na dziś, rzeczy które się ślimaczą i Twoje rutyny. Osobno dla Pracy i Prywatnego.",
  tasks:
    "Wszystkie Twoje zadania w jednym miejscu, każde przypięte do obszaru (klient, dom, zdrowie…). Osobno dla Pracy i Prywatnego.",
  routines:
    "Nawyki do regularnego odhaczania (np. poranny przegląd, suplementy). Zbiera serię dni, żeby było widać regularność.",
  zdrowie:
    "Twój panel zdrowia (osobna strona): tropy, lewary, suplementy i dziennik. Otwiera się jako pełna strona, bo żyje obok apki.",
  trakcja:
    "Stan wszystkich Twoich projektów naraz: etap, czy idą do przodu (zielone/żółte/czerwone), co je blokuje i co czeka na Ciebie.",
  ekosystem:
    "Mapa Twoich aplikacji i projektów — co żyje, co stoi, i jak się ze sobą łączą (apka ↔ projekt ↔ wątki pracy).",
  dashboard:
    "Przegląd pracy agentów AI: ile sesji, ile zdarzeń, co dzieje się teraz. Narzędzie podglądu Claude Code.",
  agentBoard:
    "Tablica Kanban z sesjami i agentami AI — widok kart „co się dzieje” w pracy agentów.",
  sessions:
    "Lista wszystkich rozmów (sesji) z agentami AI — co robiły, jak długo i ile kosztowały.",
  activityFeed:
    "Strumień zdarzeń na żywo z pracy agentów — co kliknęły, co napisały, krok po kroku.",
  analytics:
    "Statystyki pracy agentów: zużycie tokenów, koszty, najczęstsze narzędzia, błędy.",
  workflows:
    "Jak główny agent rozdzielał pracę na podagentów i jak im szło — analiza orkiestracji.",
  ccConfig:
    "Podgląd ustawień Claude Code (skille, agenci, MCP). Narzędzie techniczne — zwykle go nie ruszasz.",
  run:
    "Uruchamianie Claude bezpośrednio z apki. Zaawansowane — odpala komendy, używaj ostrożnie.",
  infrastructure:
    "Stan Twoich serwerów i aplikacji (czy żyją): hermes, vantageos, vantageflow i inne.",
  settings:
    "Ustawienia apki: powiadomienia, eksport danych, status połączeń. Rzeczy techniczne.",
};
